import { debounce } from 'lodash'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router'
import { useMediaQuery } from '@mui/material'
import { Form, Row, Col } from 'react-bootstrap'
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  BulkUsersFilter,
  SidebarListTypes
} from '../../helpers/constants/message'
import {
  setChatFilters,
  fetchBulkSendMetadataStart
} from '../../store/actions/ChatAction'
import ChatroomList from './ChatroomList'
import ChatUserList from './ChatUserList'
import { ChatroomsFilter } from './MessageIndex'
import { isModel } from '../../helpers/storage/user'
import PrimaryButton from '../Buttons/PrimaryButton'
import OutlinedButton from '../Buttons/OutlinedButton'
import SecondaryButton from '../Buttons/SecondaryButton'
import { SpinnerLoader } from '../../components/Loader/ChatLoader'

export const SidebarFilter = ({ handleSidebarClass, onNewConversation }) => {
  const dispatch = useDispatch()
  const isDesktop = useMediaQuery('(min-width:600px)')
  const chatFilters = useSelector(
    (state) => state.chat.chatFilters
  )

  useEffect(() => {
    dispatch(fetchBulkSendMetadataStart())
  }, [])

  return (
    <>
      {chatFilters.sidebarListType ===
        SidebarListTypes.Chatrooms && (
        <Row className="maintabviewchat w-100">
          <Col xs={6}>
            <PrimaryButton
              className={'w-100'}
              title={`New Conversation`}
              onClick={() => onNewConversation()}
            />
          </Col>
          {isModel() && (
            <Col xs={6}>
              <SecondaryButton
                className={'w-100'}
                title={`Bulk Message`}
                onClick={() =>
                  dispatch(
                    setChatFilters({
                      sidebarListType: SidebarListTypes.Users
                    })
                  )
                }
              />
            </Col>
          )}
        </Row>
      )}
      {chatFilters.sidebarListType === SidebarListTypes.Users && (
        <Row className="maintabviewchat">
          <Col xs={6}>
            <OutlinedButton
              title='&larr;  Go Back'
              className="float-left"
              onClick={() =>
                dispatch(
                  setChatFilters({
                    sidebarListType: SidebarListTypes.Chatrooms
                  })
                )
              }
            />
          </Col>
          {!isDesktop && (
            <Col xs={6}>
              <PrimaryButton
                className={'float-right'}
                title='Continue  &rarr;'
                onClick={() => handleSidebarClass()}
              />
            </Col>
          )}
        </Row>
      )}
      <hr />
      {chatFilters.sidebarListType ===
        SidebarListTypes.Chatrooms && (
        <ChatroomsSidebar handleSidebarClass={handleSidebarClass} />
      )}
      {chatFilters.sidebarListType === SidebarListTypes.Users && (
        <UsersSidebar />
      )}
    </>
  )
}

export const ChatroomsSidebar = ({ handleSidebarClass }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const chatFilters = useSelector((state) => state.chat.chatFilters)

  function selectChatroom(chatroom) {
    handleSidebarClass()
    navigate(`/inbox?room=${chatroom?.id}`)
  }

  const isActive = (value) => {
    return value === chatFilters.chatroomsFilter ? 'active' : ''
  }

  const handleSearchInputChange = (e) => {
    dispatch(setChatFilters({ chatroomSearhcQuery: e.target.value }))
  }

  const debouncedSearch = useMemo(() => {
    return debounce(handleSearchInputChange, 500)
  }, [handleSearchInputChange])

  return (
    <>
      <div className="post-heading">
        <h1 className="chat-conversation-title w-full">Conversations</h1>
      </div> 
      <div className="btnviewrecent mt-1 mb-1">
        <button
          className={`btn btn-primary greybtn ${isActive(
            ChatroomsFilter.Active
          )}`}
          onClick={() =>
            dispatch(
              setChatFilters({
                chatroomsFilter: ChatroomsFilter.Active
              })
            )
          }
        >
          Active
        </button>
        <button
          className={`btn btn-primary greybtn ${isActive(
            ChatroomsFilter.Blocked
          )}`}
          onClick={() =>
            dispatch(
              setChatFilters({
                chatroomsFilter: ChatroomsFilter.Blocked
              })
            )
          }
        >
          Blocked
        </button>
        <button
          className={`btn btn-primary greybtn ${isActive(
            ChatroomsFilter.Hidden
          )}`}
          onClick={() =>
            dispatch(
              setChatFilters({
                chatroomsFilter: ChatroomsFilter.Hidden
              })
            )
          }
        >
          Hidden
        </button>
        <button
          className={`btn btn-primary greybtn ${isActive(
            ChatroomsFilter.All
          )}`}
          onClick={() =>
            dispatch(
              setChatFilters({
                chatroomsFilter: ChatroomsFilter.All
              })
            )
          }
        >
          All
        </button>
      </div>
      <div className="searchpartview">
        <Form translate='no'>
          <Form.Group className="" controlId="formSearch">
            <Form.Control
              type="search"
              placeholder="Search..."
              onChange={debouncedSearch}
              // value={chatFilters?.chatroomSearhcQuery}
            />
            <Button type="submit" className="primary searchviewbtn"></Button>
          </Form.Group>
        </Form>
      </div>

      <div className="chatwindowlist">
        <ul>
          <ChatroomList selectChatroom={selectChatroom}/>
        </ul>
      </div>
    </>
  )
}

export const UsersSidebar = () => {
  const dispatch = useDispatch()
  const chatFilters = useSelector((state) => state.chat.chatFilters)
  const bulkSendMetadata = useSelector((state) => state.chat.bulkSendMetadata)

  const isActive = (index) => {
    return index === chatFilters.bulkUsersFilter ? 'active' : ''
  }

  const setSearchQuery = (value) => {
    setChatFilters({ searhcQuery: value })
  }

  return (
    <>
      <div className="sendname">
        <label>
          <strong> Send To</strong>{' '}
        </label>
      </div>
      <div className="btnviewrecent">
        <button
          className={`btn btn-primary greybtn ${isActive(
            BulkUsersFilter.Active
          )}`}
          onClick={() =>
            dispatch(
              setChatFilters({
                bulkUsersFilter: BulkUsersFilter.Active
              })
            )
          }
        >
          Active{' '}
          <div>
            {bulkSendMetadata.load ? (
              <SpinnerLoader />
            ) : (
              <>({bulkSendMetadata.data?.active || 0})</>
            )}
          </div>
        </button>
        <button
          className={`btn btn-primary greybtn ${isActive(
            BulkUsersFilter.Subscriber
          )}`}
          onClick={() =>
            dispatch(
              setChatFilters({
                bulkUsersFilter: BulkUsersFilter.Subscriber
              })
            )
          }
        >
          Subscribers{' '}
          <div>
              {bulkSendMetadata.load ? (
                <SpinnerLoader />
              ) : (
                <>({bulkSendMetadata.data?.subscribers || 0})</>
              )}
          </div>
        </button>
        <button
          className={`btn btn-primary greybtn ${isActive(
            BulkUsersFilter.Followers
          )}`}
          onClick={() =>
            dispatch(
              setChatFilters({
                bulkUsersFilter: BulkUsersFilter.Followers
              })
            )
          }
        >
          {' '}
          Follower{' '}
          <div>            
            {bulkSendMetadata.load ? (
              <SpinnerLoader />
            ) : (
              <>({bulkSendMetadata.data?.followers || 0})</>
            )}
          </div>
        </button>
      </div>
      <div className="searchpartview">
        <Form translate='no'>
          <Form.Group className="" controlId="formSearch">
            <Form.Control
              type="search"
              placeholder="Search..."
              value={chatFilters.chatroomSearch}
              onChange={(e) => {
                setSearchQuery(e.target.value)
              }}
            />
            <Button type="submit" className="primary searchviewbtn"></Button>
          </Form.Group>
        </Form>
      </div>
      <div className="chatwindowlist bulk">
        <ul>
          {bulkSendMetadata.loading ? (
            <SpinnerLoader />
          ) : (
            <ChatUserList searchQuery={chatFilters.chatroomSearch} />
          )}
        </ul>
      </div>
    </>
  )
}
